import { IconButton, makeStyles, Tooltip } from '@material-ui/core';
import { Edit, FindInPage, Search } from '@material-ui/icons';
import MaterialTable from 'material-table';
import { useContext, useState } from 'react';
import { LoginContext } from '../../contexts/LoginContext';
import { defaultGridOptions, tooltipDelay, useGridColDefs } from '../../utils/GridUtils';
import ClaimDetailsModal from './ClaimDetailsModal/ClaimDetailsModal';
import { centeredCell } from '../../constants/StyleConstants';
import CheckCircleOutlinedIcon from '@material-ui/icons/CheckCircleOutlined';
import UpdateOutlinedIcon from '@material-ui/icons/UpdateOutlined';
import DialogAcerBrag from '../../components/UI/DialogAcerBrag';
import FileDownloaderAcerBrag from '../../components/UI/FileDownloaderAcerBrag';
import { decodeFile } from '../../utils/MiscellaneousUtils';
import { AppContext } from '../../contexts/AppContext';
import ClaimsAPI from '../../services/ClaimsAPI';

const useStyles = makeStyles(theme => ({
  centeredCell,
}));

const ClaimManagementGrid = ({ data, loading, reloadGrid, dataDerivation }) => {
  const classes = useStyles();
  const { isSupplier, isAllowedByRole } = useContext(LoginContext);
  const { showError } = useContext(AppContext);
  const [open, setOpen] = useState(false);
  const [readOnly, setReadOnly] = useState(false);
  const [claimId, setClaimId] = useState(null);

  const [openFiles, setOpenFiles] = useState(false);
  const [fileNames, setFileNames] = useState([]);

  const handleDownloadFile = (id, fileName) => {
    return ClaimsAPI.getFile(id, fileName)
      .then(res => decodeFile(res, fileName))
      .catch(error => showError('No se pudo descargar el archivo solicitado'));
  };
  const handleOpenDetails = (id, readOnly) => {
    setReadOnly(readOnly);
    setClaimId(id);
    setOpen(true);
  };
  const ReplyDerivation = ({value, rowData})=>{
    const derivation = rowData.lastDerivation;
    return (value===null?derivation:value);
  }

  const colDefs = useGridColDefs([
    {
      title: '',
      field: 'actions',
      sorting: false,
      valueType: 'icon',
      valueRender: (value, rowData) => (
        <div>
          <Tooltip title="Ver detalles" enterDelay={tooltipDelay} enterNextDelay={tooltipDelay}>
            <IconButton aria-label="visualizar" size="small" color="primary" onClick={() => {handleOpenDetails(rowData.id, true)}} >
              <Search />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
    {
      title: '',
      field: 'actions',
      sorting: false,
      valueType: 'icon',
      valueRender: (value, rowData) => (
        <div>
          {!isSupplier && (
            <Tooltip title={'Editar'} enterDelay={tooltipDelay} enterNextDelay={tooltipDelay}>
              <span>
                <IconButton
                  disabled={!rowData.state}
                  aria-label="visualizar"
                  size="small"
                  color="primary"
                  onClick={() => handleOpenDetails(rowData.id, false)}>
                  <Edit />
                </IconButton>
              </span>
            </Tooltip>
          )}
        </div>
      ),
    },
    { title: 'ID', field: 'id', valueType: 'id'},
    {
      title: 'Tipo Reclamo',
      field: 'claimType',
      valueRender: (value, rowData) => (
        <Tooltip arrow title={value} enterDelay={tooltipDelay} enterNextDelay={tooltipDelay}>
          <span>{value}</span>
        </Tooltip>
      ),
    },
    { title: 'Descripción', field: 'description' },
    { title: 'Fecha de Alta', field: 'startDate', valueType: 'date' },
    { title: 'Derivado', field: 'area', valueRender: (value, rowData) => value.toTitleCase() },
    { title: 'Respuesta', field: 'reply', valueRender: (value, rowData) => <ReplyDerivation value={value} rowData={rowData}/> },
    { title: 'Fecha de Cierre', field: 'endDate', valueType: 'date' },
    {
      title: 'Adjuntos',
      field: 'files',
      valueType: 'icon',
      valueRender: (value, rowData) => (
        <Tooltip title={value ? 'Ver adjuntos' : 'No se encontraron adjuntos'} enterDelay={tooltipDelay} enterNextDelay={tooltipDelay}>
          <span>
            <IconButton
              disabled={!value}
              aria-label="visualizar"
              size="small"
              color="primary"
              onClick={() => {
                if (isAllowedByRole()) {
                  setFileNames(value);
                  setClaimId(rowData.id);
                  setOpenFiles(true);
                }
              }}>
              <FindInPage />
            </IconButton>
          </span>
        </Tooltip>
      ),
    },
    {
      title: 'Estado',
      field: 'state',
      valueType: 'icon',
      valueRender: (value, rowData) => {
        return (
          <div className={classes.centeredCell}>
            <Tooltip title={value ? 'Abierto' : 'Cerrado'} enterDelay={tooltipDelay} enterNextDelay={tooltipDelay}>
              {value ? <UpdateOutlinedIcon color="secondary" /> : <CheckCircleOutlinedIcon color="primary" />}
            </Tooltip>
          </div>
        );
      },
    },
    
  ]);
  const colDefsUser = useGridColDefs([
    {
      title: '',
      field: 'actions',
      sorting: false,
      valueType: 'icon',
      valueRender: (value, rowData) => (
        <div>
          <Tooltip title="Ver detalles" enterDelay={tooltipDelay} enterNextDelay={tooltipDelay}>
            <IconButton aria-label="visualizar" size="small" color="primary" onClick={() => {handleOpenDetails(rowData.id, true)}}>
              <Search />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
    {
      title: '',
      field: 'actions',
      sorting: false,
      valueType: 'icon',
      valueRender: (value, rowData) => (
        <div>
          {!isSupplier && (
            <Tooltip title={'Editar'} enterDelay={tooltipDelay} enterNextDelay={tooltipDelay}>
              <span>
                <IconButton
                  disabled={!rowData.state}
                  aria-label="visualizar"
                  size="small"
                  color="primary"
                  onClick={() => handleOpenDetails(rowData.id, false)}>
                  <Edit />
                </IconButton>
              </span>
            </Tooltip>
          )}
        </div>
      ),
    },
    { title: 'ID', field: 'id', valueType: 'id'},
    {
      title: 'Proveedor',
      field: 'supplier',
      valueRender: (value, rowData) => (
        <Tooltip arrow title={value} enterDelay={tooltipDelay} enterNextDelay={tooltipDelay}>
          <span>{value}</span>
        </Tooltip>
      ),
    },
    {
      title: 'Tipo Reclamo',
      field: 'claimType',
      valueRender: (value, rowData) => (
        <Tooltip arrow title={value} enterDelay={tooltipDelay} enterNextDelay={tooltipDelay}>
          <span>{value}</span>
        </Tooltip>
      ),
    },
    { title: 'Descripción', field: 'description' },
    { title: 'Fecha de Alta', field: 'startDate', valueType: 'date' },
    { title: 'Derivado', field: 'area', valueRender: (value, rowData) => value.toTitleCase() },
    { title: 'Fecha de Cierre', field: 'endDate', valueType: 'date' },
    {
      title: 'Adjuntos',
      field: 'files',
      valueType: 'icon',
      valueRender: (value, rowData) => (
        <Tooltip title={value ? 'Ver adjuntos' : 'No se encontraron adjuntos'} enterDelay={tooltipDelay} enterNextDelay={tooltipDelay}>
          <span>
            <IconButton
              disabled={!value}
              aria-label="visualizar"
              size="small"
              color="primary"
              onClick={() => {
                if (isAllowedByRole()) {
                  setFileNames(value);
                  setClaimId(rowData.id);
                  setOpenFiles(true);
                }
              }}>
              <FindInPage />
            </IconButton>
          </span>
        </Tooltip>
      ),
    },
    {
      title: 'Estado',
      field: 'state',
      valueType: 'icon',
      valueRender: (value, rowData) => {
        return (
          <div className={classes.centeredCell}>
            <Tooltip title={value ? 'Abierto' : 'Cerrado'} enterDelay={tooltipDelay} enterNextDelay={tooltipDelay}>
              {value ? <UpdateOutlinedIcon color="secondary" /> : <CheckCircleOutlinedIcon color="primary" />}
            </Tooltip>
          </div>
        );
      },
    },
  ]);
  return (
    <>
      <DialogAcerBrag open={openFiles} setOpen={setOpenFiles} title="Adjuntos">
        <FileDownloaderAcerBrag data={fileNames} action={fileName => handleDownloadFile(claimId, fileName)} />
      </DialogAcerBrag>
      <ClaimDetailsModal open={open} setOpen={setOpen} claimId={claimId} readOnly={readOnly} reloadGrid={reloadGrid} />
      <MaterialTable {...defaultGridOptions} columns={isSupplier ? colDefs : colDefsUser} data={data} isLoading={loading}/>
    </>
  );
};

export default ClaimManagementGrid;
